import Styles from './styles.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CrossDomainLink from '../crossDomainLink';

const navItems = [
    { label: 'Главная', type: 'internal', href: '/' },
    { label: 'Частным лицам', type: 'react', path: '/personal' },
    { label: 'Бизнесу', type: 'react', path: '/business' },
    { label: 'Возможности', type: 'react', path: '/features' },
    { label: 'Карты', type: 'react', path: '/cards' },
    { label: 'Депозит', type: 'internal', href: '/deposit' },
];

const Navigation = ({ isMobile }) => {
    const { t } = useTranslation();

    return (
        <nav className={isMobile ? Styles.mobileNav : Styles.navWrap}>
            {navItems.map((item) =>
                item.type === 'internal' ? (
                    <Link
                        key={item.label}
                        to={item.href}
                        className={Styles.navItem}
                    >
                        {t(item.label)}
                    </Link>
                ) : (
                    <CrossDomainLink
                        key={item.label}
                        path={item.path}
                        className={Styles.navItem}
                    >
                        {t(item.label)}
                    </CrossDomainLink>
                )
            )}
        </nav>
    );
};

export default Navigation;
